import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { checkUserAuth } from 'utils/author';
import { useCheckIsWalmartAuthorization } from 'hooks/router';
import { useUserInfo } from 'hooks/auth/useUserInfo';

const PrivateRoute = ({ children, validateFn = () => {}, returnUrl }) => {
  const location = useLocation();
  const { userInfo } = useUserInfo();

  const { isWalmartAuthorize, walmartSearchQuery } =
    useCheckIsWalmartAuthorization();

  const currentPath = location.pathname + location.search;
  const finalReturnUrl = returnUrl || currentPath;

  const isValidRoute = validateFn();
  const isAuthenticated = checkUserAuth(userInfo);
  const isRedirectToWaiting =
    !isAuthenticated && location.pathname !== '/waiting';

  if (!isValidRoute) {
    const loginPath = isWalmartAuthorize
      ? `/login${walmartSearchQuery}`
      : `/login?returnUrl=${encodeURIComponent(finalReturnUrl)}`; // ✅ Use current location

    return <Navigate to={loginPath} replace />;
  }

  if (isRedirectToWaiting) {
    const waitingPath = isWalmartAuthorize
      ? `/waiting${walmartSearchQuery}`
      : `/waiting?returnUrl=${encodeURIComponent(finalReturnUrl)}`; // ✅ Use current location

    return <Navigate to={waitingPath} replace />;
  }

  return children;
};

export default PrivateRoute;
